// IconWrapper.tsx
import type { SVGProps } from 'react';
import * as React from 'react';
import { cn } from '@utils/cn.ts';

type IconChild = React.ReactElement<SVGProps<SVGSVGElement>>;

type IconWrapperProps = {
  className?: string;
  children: IconChild;
  tag?: React.ReactElement;
  onClick?: (e: any) => void;
};

export function IconWrapper({ className, children, onClick, tag }: IconWrapperProps) {
  const child = React.cloneElement(children, {
    className: cn('w-full h-full', children.props.className),
    width: '100%',
    height: '100%',
  });

  return (
    <div className={'flex-inline flex-row inline-flex items-center justify-center'}>
      <span className={cn('', className)} aria-hidden="true" onClick={onClick}>
        {child}
      </span>
      {tag && (
        <div className={`-ml-[10px] -mt-[20px] ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
          {tag}
        </div>
      )}
    </div>
  );
}
